import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'nw-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class NewellDateTimePickerComponent implements OnInit {

  public scheduledDate = new Date();
  public readonly minDate = new Date();

  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() enableMeridian: boolean = false;

  @Input() value: Date = new Date();
  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() change: EventEmitter<Date> = new EventEmitter<Date>();

  @Input() min: Date;
  @Input() max: Date;



  constructor() { }

  ngOnInit(): void {
  }

}
